import { Card, Elevation } from "@blueprintjs/core";
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import flatProfile from '../../assets/flatProfile.png';
import flatProfileTrans from '../../assets/flatProfileTrans.png';
import ImageModal from '../../components/image-modal';
import dateUtils from '../../../utils/date';
import arrayUtils from '../../../utils/array';
import numberUtils from '../../../utils/number';
import Sugar from "sugar";

const amenitiesMap = {
  gas: 'pipe',
  intercom: 'intercom',
  "swim-pool": 'swimmer',
  badminton: 'badminton',
  "table-tennis": 'sports-and-competition',
  "lawn-tennis": 'ball',
  lift: 'lift',
  gym: 'gym',
  "club-house": 'house',
  //"child-play-area": '',
  "visitors-parking": 'car',
  "fire-safety": 'extinguisher',
  security: 'guard',
  "power-back-up": 'smart',
  inverter: 'power', //not in amenities API list
  ac: 'air-conditioner',
  "water-purifier": 'water',
  "washing-achine": 'household',
  "modular-kitchen": 'kitchen',
  geyser: 'water-heater',
  bed: 'room',
  wardrobe: 'closet',
  "video-door-phone": 'music-and-multimedia',
}

class ViewPropertyCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageModal: false,
      imageObj: null,
      propertyAmenitiesGroup: null,
      societyAmenitiesGroup: null,
      relativeRegistartionDate: '',
    }
  }

  componentWillMount() {

    if (this.props.data.property.society.mhkRegistrationDate) {
      let registrationDate = Sugar.Date.create(this.props.data.property.society.mhkRegistrationDate)
      this.setState({
        relativeRegistartionDate: Sugar.Date.relative(registrationDate)
      })
    }
    const propertyCounts = this.props.data.property.society.societyWings.reduce((agg, current) => {
      agg.flats += current.propertyCounts["Flat"] || 0;
      agg.bungalows += current.propertyCounts["Bungalow"] || 0;
      agg.shops += current.propertyCounts["Shop"] || 0;
      return agg;
    }, { flats: 0, bungalows: 0, shops: 0 });
    this.setState({
      propertyAmenitiesGroup: arrayUtils.groupObjects(this.props.data.property.amenities, "amenityGroup"),
      societyAmenitiesGroup: arrayUtils.groupObjects(this.props.data.property.society.amenities, "amenityGroup"),
      propertyCounts
    })
  }

  showImageGalery = (obj) => {
    if (obj.photos && obj.photos.length) {
      console.log(obj)
      this.setState({
        imageObj: obj,
        imageModal: true
      })
    }
  }

  hideImageGallery = () => {
    this.setState({
      imageModal: false
    })
  }

  getBrokerage = () => {
    let brokerage = 0;
    if (this.props.data.inventoryType === 'Sell' && this.props.data.sellPrice) {
      brokerage = parseInt(this.props.data.sellPrice) * 0.01;
    } else if (this.props.data.inventoryType === 'Rent' && this.props.data.leaseMonthlyRentAmount) {
      brokerage = this.props.data.leaseMonthlyRentAmount;
    }
    return numberUtils.intoReadableAmount(brokerage);
  }

  render() {
    let inventoryType = this.props.data.inventoryType;
    if (inventoryType === 'Sell') {
      inventoryType = 'Sale'
    }
    let imgSrc = flatProfile;
    if (this.props.data.property.photos && this.props.data.property.photos.length) {
      imgSrc = this.props.data.property.photos[0].url || flatProfileTrans;
    }
    let societyImgSrc = flatProfile;
    if (this.props.data.property.society.photos && this.props.data.property.society.photos.length) {
      societyImgSrc = this.props.data.property.society.photos[0].url || flatProfileTrans;
    }
    return (
      <section className="section">
        <ImageModal show={this.state.imageModal} obj={this.state.imageObj} hideImageGallery={this.hideImageGallery} />
        <div className="container">
          <Card className="card property-card" elevation={Elevation.ONE} style={{ marginBottom: "1rem" }}>
            <div className="columns is-size-5" style={{ lineHeight: 1.5 }}>
              <div className="column is-5">
                <div className="property-details-name">
                  <strong>{this.props.data.property.bedroomCount}BHK for {inventoryType}</strong>
                  <br />
                  {this.props.data.property.society ?
                    `${this.props.data.property.society.name}, ${this.props.data.property.society.address}` : null}
                </div>
              </div>
              <div className="column">
                <span className="has-text-grey has-text-weight-light">{inventoryType === 'Sale' ? "Cost:" : "Rent:"}</span>
                <br />
                <strong className="is-amount">{inventoryType === 'Sale' ? numberUtils.intoReadableAmount(this.props.data.sellPrice) : numberUtils.intoReadableAmount(this.props.data.leaseMonthlyRentAmount)}</strong>
                <br />
                {this.props.data.isNegotiable ? '(Negotiable)' : null}
              </div>
              <div className="column">
                <span className="has-text-grey has-text-weight-light">Brokerage:</span>
                <br />
                <div className="is-amount">
                  {this.getBrokerage()}
                </div>
              </div>
              <div className="column">
                <span className="has-text-grey has-text-weight-light">Posted On:</span>
                <br />
                {this.state.relativeRegistartionDate}
              </div>
            </div>
            <hr />
            <div className="columns">
              <div className="column is-narrow">
                <div style={{ position: "relative" }}>
                  <img src={imgSrc} alt="" className="prop-img" style={{ display: "block" }}
                    onClick={() => this.showImageGalery(this.props.data.property)} />
                  {this.props.data.property.photos.length ?
                    <div className="available-photo">{this.props.data.property.photos.length} Photos Available</div>
                    : null}
                </div>
              </div>
              <div className="column">
                <div className="columns is-multiline is-1 is-variable is-mobile property-details">
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-bed flat-icon" />
                      <span>Bedrooms: {this.props.data.property.bedroomCount}</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-shower flat-icon" />
                      <span>&nbsp;Bathrooms: {this.props.data.property.bathroomCount}</span>
                    </div>
                  </div>
                  {
                    inventoryType === "Rent" ?
                      <div className="column is-6">
                        <div className="has-text-grey d-flex details-col-title">
                          <i className="flaticon-child flat-icon" />
                          <span>&nbsp;Tenant: {this.props.data.customerPreference}</span>
                        </div>
                      </div> : null
                  }
                  {inventoryType === "Rent" ?
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-sofa flat-icon" />
                        <span>&nbsp;Furnishing: {this.props.data.property.furnishType}</span>
                      </div>
                    </div> : null
                  }
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-ruler flat-icon" />
                      <span>&nbsp;Super Built Up: {this.props.data.property.superBuiltupArea} Sq.Ft</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-ruler-1 flat-icon" />
                      <span>&nbsp;Carpet: {this.props.data.property.carpetArea} Sq.Ft</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-window flat-icon" />
                      <span>&nbsp;Balconies: {this.props.data.property.balconyCount}</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-birthday flat-icon" />
                      <span>&nbsp;Age: {this.props.data.property.society.completionYear ?
                        dateUtils.calculateAge(this.props.data.property.society.completionYear)
                        : 'NA'
                      }</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      {/* Default svg icon */}
                      <i className="flaticon-ruler flat-icon" />
                      <span>Floor: {this.props.data.property.floorNumber}</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      <i className="flaticon-compass flat-icon" />
                      <span>&nbsp;Facing: {this.props.data.property.propertyFacing}</span>
                    </div>
                  </div>
                  <div className="column is-6">
                    <div className="has-text-grey d-flex details-col-title">
                      {/* Default svg icon */}
                      <i className="flaticon-parking flat-icon" />
                      <span>&nbsp;Parking: {this.props.data.property.parkings.length ?
                        arrayUtils.countObjects(this.props.data.property.parkings, "parkingType")
                        : 'NA'
                      }</span>
                    </div>
                  </div>
                  <div className="column is-12">
                    <div className="btn-contain">
                      <div className="btn-block">
                        <Link
                          to={`/visitproperty/${this.props.data.uid}`}
                          className="bp3-button bp3-intent-success bp3-fill bp3-large"
                        >
                          Visit Property
                    </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card className="description-card">
            <div className="content">
              <h3 className="details-title">Description</h3>
              <p>
                {this.props.data.description || <span className="has-text-grey">Description Not Available</span>}
              </p>
            </div>
          </Card>
          <Card className="card description-card" elevation={Elevation.ONE} style={{ marginBottom: "1rem" }}>
            <div className="content">
              <h3 className="details-title" style={{ marginBottom: "2rem" }}>Amenities</h3>
              <div>
                {
                  this.state.propertyAmenitiesGroup ?
                    Object.keys(this.state.propertyAmenitiesGroup).map(key => (
                      <Fragment key={key}>
                        <div className="columns is-multiline is-mobile">
                          {this.state.propertyAmenitiesGroup[key].map(amn => (
                            <div className="column is-6-mobile is-4" key={amn.uid}>
                              <div className="amenities-container">
                                <i className={`flaticon-${amenitiesMap[amn.uid]} flat-icon amenities-icon`} />
                                <span>{amn.name}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Fragment>
                    ))
                    : null
                }
                {
                  this.state.societyAmenitiesGroup ?
                    Object.keys(this.state.societyAmenitiesGroup).map(key => (
                      <Fragment key={key}>
                        <div className="columns is-multiline is-mobile">
                          {this.state.societyAmenitiesGroup[key].map(amn => (
                            <div className="column is-6-mobile is-4" key={amn.uid}>
                              <div className="amenities-container">
                                <i className={`flaticon-${amenitiesMap[amn.uid]} flat-icon amenities-icon`} />
                                <span>{amn.name}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Fragment>
                    ))
                    : null
                }
              </div>
            </div>
          </Card>
          <Card className="card property-card" elevation={Elevation.ONE} style={{ marginBottom: "1rem" }}>
            <div className="content society-details">
              <h3 className="details-title">Society</h3>
              <div className="columns">
                <div className="column is-narrow">
                  <div style={{ position: "relative" }}>
                    <img src={societyImgSrc} alt="" className="prop-img" style={{ display: "block" }}
                      onClick={() => this.showImageGalery(this.props.data.property.society)} />
                    {this.props.data.property.society.photos.length ?
                      <div className="available-photo">{this.props.data.property.society.photos.length} Photos Available</div>
                      : null}
                  </div>
                </div>
                <div className="column">
                  <div className="columns is-multiline is-1 is-variable is-mobile property-details">
                    <div className="column is-12 col-thin">
                      <div className="is-size-5">{this.props.data.property.society.name}</div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-pin flat-icon" />
                        <span>&nbsp;Area: {this.props.data.property.society.address || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-tower flat-icon" />
                        <span>&nbsp;Towers: {this.props.data.property.society.societyWings.length || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-calendar flat-icon" />
                        <span>&nbsp;Completed On: {this.props.data.property.society.completionYear || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-block flat-icon" />
                        <span>&nbsp;Flats: {this.state.propertyCounts.flats || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-brick flat-icon" />
                        <span>&nbsp;Constructed By: {this.props.data.property.society.constructedBy || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-shop flat-icon" />
                        <span>&nbsp;Shops: {this.state.propertyCounts.shops || 'NA'}</span>
                      </div>
                    </div>
                    <div className="column is-6">
                      <div className="has-text-grey d-flex details-col-title">
                        <i className="flaticon-house flat-icon" />
                        <span>&nbsp;Bungalow: {this.state.propertyCounts.bungalows || 'NA'}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>
    );
  }
}

export default ViewPropertyCard;


// WEBPACK FOOTER //
// ./src/app/containers/viewPropertyCard/index.js